'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _reduxActions = require('redux-actions');

var _immutable = require('immutable');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _StubbedThreadHistoryActionTypes = require('../../stubbed-thread-history/constants/StubbedThreadHistoryActionTypes');

var _stubbedChannel = require('../constants/stubbedChannel');

var _KeyPaths = require('conversations-schema/thread/constants/KeyPaths');

var KEY_PATHS = _interopRequireWildcard(_KeyPaths);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _threadSetters = require('conversations-schema/thread/operators/threadSetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _setLatestMessage = require('conversations-schema/thread/operators/setLatestMessage');

var _setAssignedAgentFromV2Message = require('conversations-schema/thread/operators/setAssignedAgentFromV2Message');

var _setAssignedAgentFromV1Message = require('conversations-schema/thread/operators/setAssignedAgentFromV1Message');

var _isAssignmentV = require('conversations-schema/pubnub-message/operators/isAssignmentV1');

var _isAssignmentV2 = require('conversations-schema/pubnub-message/operators/isAssignmentV2');

var _isEmailCaptureResponseMessage = require('conversations-schema/pubnub-message/operators/isEmailCaptureResponseMessage');

var _ConversationsModel = require('conversations-schema/models/ConversationsModel');

var _buildConversation = require('conversations-schema/factories/ConversationFactory/buildConversation');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL, ActionTypes.ADD_CONVERSATION), function (state, action) {
  var conversation = action.payload.conversation;

  var channel = (0, _threadGetters.getChannel)(conversation);
  return state.set(channel, conversation);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.GET_PAGINATED_CONVERSATIONS_SUCCEEDED, ActionTypes.GET_CONVERSATIONS_SUCCEEDED, ActionTypes.ADD_CONVERSATIONS_TO_MAP, ActionTypes.GET_INITIAL_CONVERSATION_SUCCEEDED), function (state, action) {
  var threads = action.payload.threads;

  var newThreads = threads.map(_buildConversation.buildConversation).reduce(function (acc, thread) {
    return acc.set((0, _threadGetters.getChannel)(thread), thread);
  }, (0, _immutable.Map)());
  return state.merge(newThreads);
}), _defineProperty(_handleActions, ActionTypes.ADD_MESSAGE_TO_CONVERSATION, function (state, action) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      message = _action$payload.message;


  var threadId = (0, _ConversationsModel.findThreadIdWithChannel)(state, channel);
  var messageWithThreadId = (0, _threadSetters.setThreadId)(threadId, message);

  return state.update(channel, (0, _pipe2.default)((0, _ifThen2.default)(function () {
    return (0, _isAssignmentV2.isAssignmentV2)(messageWithThreadId);
  }, (0, _setAssignedAgentFromV2Message.setAssignedAgentFromV2Message)(messageWithThreadId)), (0, _ifThen2.default)(function () {
    return (0, _isAssignmentV.isAssignmentV1)(messageWithThreadId);
  }, (0, _setAssignedAgentFromV1Message.setAssignedAgentFromV1Message)(messageWithThreadId)), (0, _ifThen2.default)((0, _both2.default)(function () {
    return (0, _messageTypeComparators.isConversationalMessage)(message);
  }, function () {
    return !(0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(message);
  }), (0, _setLatestMessage.setLatestMessage)(message))));
}), _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.ADD_MESSAGE_TO_STUBBED_CHANNEL, function (state, action) {
  var message = action.payload.message;


  return state.update(_stubbedChannel.STUBBED_CHANNEL, (0, _ifThen2.default)((0, _both2.default)(function () {
    return (0, _messageTypeComparators.isConversationalMessage)(message);
  }, function () {
    return !(0, _isEmailCaptureResponseMessage.isEmailCaptureResponseMessage)(message);
  }), (0, _setLatestMessage.setLatestMessage)(message)));
}), _defineProperty(_handleActions, ActionTypes.INCREMENT_UNSEEN_COUNT, function (state, action) {
  var channel = action.payload.channel;

  try {
    return state.updateIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, KEY_PATHS.UNSEEN_COUNT), function (unseenCount) {
      return unseenCount + 1;
    });
  } catch (err) {
    window.Raven.captureMessage('updateIn', {
      extra: {
        err: err,
        action: action
      }
    });
    return state;
  }
}), _defineProperty(_handleActions, ActionTypes.CLEAR_UNSEEN_COUNT_FOR_CHANNEL, function (state, action) {
  var channel = action.payload.channel;


  var keyPath = (0, _ConversationsModel.getKeyPathOnChannel)(channel, KEY_PATHS.UNSEEN_COUNT);

  if (!(0, _getIn2.default)(keyPath, state)) {
    return state;
  }

  return state.setIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, KEY_PATHS.UNSEEN_COUNT), 0);
}), _defineProperty(_handleActions, ActionTypes.GET_VISITOR_THREADS_SUCCESS, function (state, action) {
  var visitorConversations = action.payload.threads;


  return visitorConversations.reduce(function (acc, conversation) {
    return acc.set(conversation.channel, conversation);
  }, (0, _immutable.Map)()).merge(state);
}), _defineProperty(_handleActions, ActionTypes.CREATE_VISITOR_THREAD_SUCCESS, function (state, action) {
  var _action$payload2 = action.payload,
      conversation = _action$payload2.thread,
      channel = _action$payload2.channel;


  return state.set(channel, conversation);
}), _defineProperty(_handleActions, ActionTypes.SET_THREAD_ASSIGNEE, function (state, action) {
  var _action$payload3 = action.payload,
      userId = _action$payload3.userId,
      channel = _action$payload3.channel;

  return state.setIn([channel, 'assignedAgentId'], userId);
}), _defineProperty(_handleActions, ActionTypes.LAST_SEEN_SUCCESS, function (state, action) {
  var _action$payload4 = action.payload,
      channel = _action$payload4.channel,
      latestMessageTimestamp = _action$payload4.latestMessageTimestamp;

  if (channel && latestMessageTimestamp) {
    return state.setIn([channel, 'latestReadTimestamp'], latestMessageTimestamp);
  }

  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/reducers/conversationsMap.js
// module id = 865
// module chunks = 2 3